<template>
	<div class="calculator__input">
		<div
			class="mdc-text-field mdc-text-field--text mdc-text-field--outlined"
			:class="{ 'mdc-text-field--disabled': readonly }"
		>
			<input
				:id="name"
				:value="value"
				class="mdc-text-field__input"
				:type="type"
				:name="name"
				:required="required"
				:aria-invalid="!!error"
				:aria-describedby="`${name}-hint`"
				:data-form-error="`#${name}-error`"
				:readonly="readonly"
				:min="min"
				:max="max"
				:step="step"
				@blur="onBlur"
			/>

			<div class="mdc-notched-outline">
				<div class="mdc-notched-outline__leading"></div>
				<div class="mdc-notched-outline__notch">
					<label class="mdc-floating-label" :for="name">
						{{ label }}
					</label>
				</div>
				<div class="mdc-notched-outline__trailing"></div>
			</div>
		</div>

		<InputHint :name="name" :hint="hint" :invalidHint="invalidHint" />
	</div>
</template>

<script>
import InputHint from './InputHint.vue';

export default {
	name: 'InputField',
	components: {
		InputHint
	},
	props: {
		name: String,
		value: [String, Number],
		error: String,
		label: String,
		hint: String,
		invalidHint: String,
		type: {
			type: String,
			default() {
				return 'text';
			}
		},
		required: Boolean,
		readonly: Boolean,
		min: String,
		max: String,
		step: String
	},
	mounted() {
		this.initCustomFormFields(this.$el);
	},
	methods: {
		// Properly rerender field on blur
		onBlur($event) {
			this.$forceUpdate();

			setTimeout(() => {
				try {
					$event.target.form.Bouncer.validate($event.target);
				} catch (err) {
					console.log(err); // eslint-disable-line no-console
				}
			}, 100);
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__input .mdc-text-field {
	height: 3rem;
}
.calculator__input .mdc-text-field__input {
	-moz-appearance: textfield;
	padding: 0.75rem 1rem;
}
.calculator__input .mdc-floating-label:not(.mdc-floating-label--float-above) {
	top: 0.9rem;
}
.calculator__input input::-webkit-outer-spin-button,
.calculator__input input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
</style>
